import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";

const CONTACT_EMAIL = "contact@faanuu.app";

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-tribal">
      <Navbar />
      <main className="max-w-3xl mx-auto px-6 py-12 fade-up">
        <p className="text-xs tracking-[0.3em] text-[color:var(--primary)] mb-3">LÉGAL</p>
        <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight mb-2">Politique de confidentialité</h1>
        <p className="text-sm text-[color:var(--text-secondary)] mb-8">
          Dernière mise à jour : 7 juillet 2026 · Faanuu (faanuu.app)
        </p>

        <div className="glass rounded-lg p-6 sm:p-8 space-y-8 text-sm sm:text-base text-[color:var(--text-secondary)] leading-relaxed">
          <section>
            <h2 className="text-lg font-semibold text-[color:var(--text-primary)] mb-2">1. Responsable du traitement</h2>
            <p>
              Le site <strong className="text-[color:var(--text-primary)]">Faanuu</strong> (Perē Fa&apos;anu&apos;u) est édité pour permettre de jouer en ligne au jeu polynésien du même nom.
              Pour toute question relative à vos données :{" "}
              <a href={`mailto:${CONTACT_EMAIL}`} className="text-[color:var(--primary)] hover:underline">{CONTACT_EMAIL}</a>.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[color:var(--text-primary)] mb-2">2. Données collectées</h2>
            <ul className="list-disc list-inside space-y-2 ml-1">
              <li><strong className="text-[color:var(--text-primary)]">Compte</strong> : adresse e-mail, nom, prénom, pseudo, photo de profil (optionnelle), via Clerk.</li>
              <li><strong className="text-[color:var(--text-primary)]">Jeu</strong> : statistiques (victoires, défaites, ELO), historique de parties, replays.</li>
              <li><strong className="text-[color:var(--text-primary)]">Parties en ligne</strong> : messages de chat par salon, signalements éventuels.</li>
              <li><strong className="text-[color:var(--text-primary)]">Technique</strong> : cookies de session (authentification), logs serveur (adresse IP, horodatage).</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[color:var(--text-primary)] mb-2">3. Finalités</h2>
            <p>Nous utilisons ces données pour :</p>
            <ul className="list-disc list-inside space-y-1 ml-1 mt-2">
              <li>créer et gérer votre compte ;</li>
              <li>permettre les parties en ligne, le classement et le chat ;</li>
              <li>inviter des amis via lien de partie ou messagerie ;</li>
              <li>assurer la sécurité du service et modérer les abus ;</li>
              <li>améliorer l&apos;expérience de jeu.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[color:var(--text-primary)] mb-2">4. Base légale</h2>
            <p>
              Le traitement repose sur l&apos;exécution du contrat (utilisation du jeu), votre consentement (cookies non essentiels) et notre intérêt légitime (sécurité, lutte contre la fraude).
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[color:var(--text-primary)] mb-2">5. Durée de conservation</h2>
            <ul className="list-disc list-inside space-y-1 ml-1">
              <li>Compte actif : tant que vous utilisez le service.</li>
              <li>Messages de chat : conservés par salon de partie, jusqu&apos;à suppression du compte ou demande d&apos;effacement.</li>
              <li>Logs techniques : durée limitée (quelques mois).</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[color:var(--text-primary)] mb-2">6. Partage avec des tiers</h2>
            <p>
              Nous ne vendons pas vos données. Elles peuvent être traitées par :
            </p>
            <ul className="list-disc list-inside space-y-1 ml-1 mt-2">
              <li>notre hébergeur, Clerk (authentification) et Google Firebase (profils Firestore le cas échéant), et prestataires techniques, dans le cadre strict du fonctionnement du site.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[color:var(--text-primary)] mb-2">7. Cookies</h2>
            <p>
              Des cookies <em>httpOnly</em> sécurisés sont utilisés pour maintenir votre session connectée. Vous pouvez vous déconnecter à tout moment ; refuser les cookies empêche l&apos;utilisation du compte en ligne.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[color:var(--text-primary)] mb-2">8. Vos droits</h2>
            <p>
              Conformément au RGPD, vous disposez d&apos;un droit d&apos;accès, de rectification, d&apos;effacement, de limitation, de portabilité et d&apos;opposition.
              Pour exercer ces droits ou supprimer votre compte, consultez notre page{" "}
              <Link to="/suppression-donnees" className="text-[color:var(--primary)] hover:underline">Suppression des données utilisateur</Link>{" "}
              ou écrivez à <a href={`mailto:${CONTACT_EMAIL}`} className="text-[color:var(--primary)] hover:underline">{CONTACT_EMAIL}</a>.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[color:var(--text-primary)] mb-2">9. Sécurité</h2>
            <p>
              Les mots de passe sont stockés de manière chiffrée (hachage). Les échanges avec le serveur utilisent HTTPS. Aucune mesure n&apos;étant infaillible, nous vous invitons à choisir un mot de passe robuste.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[color:var(--text-primary)] mb-2">10. Modifications</h2>
            <p>
              Cette politique peut être mise à jour. La date en tête de page sera modifiée en cas de changement substantiel.
            </p>
          </section>
        </div>

        <p className="mt-8 text-center text-xs text-[color:var(--text-secondary)]">
          <Link to="/suppression-donnees" className="text-[color:var(--primary)] hover:underline">Suppression des données</Link>
          {" · "}
          <Link to="/" className="hover:underline">Accueil</Link>
        </p>
      </main>
    </div>
  );
}
